import store from '@/store'

import {RawWikiPage} from '@/types/entity/RawWiki'

import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import TextareaField from '@/components/Ui/ActiveForm/BZCore/Fields/TextareaField'
import TreeSelectField from '@/components/Ui/ActiveForm/BZCore/Fields/TreeSelectField'
import RichTextField from '@/components/Ui/ActiveForm/BZCore/Fields/RichTextField'

// @ts-ignore
import messages from '@/lang/index';

const createForm: ActiveFormOptions = {
  label: messages.wiki.single_page_name,
  submitText: messages.wiki.edit_single_node,
  async onSubmit (data: RawWikiPage) {
    console.log('LOG: Edit Page -> data', data)
    let pageData = {
      id: data.id,
      text: data.text,
      title: data.title
    }
    await store.dispatch('wiki/updatePage', pageData)
    await store.dispatch('wiki/pageParent', {id: data.id, parent: data.parent})
  },
  inputs: {
    title: {
      label: messages.labels.title,
      type: StringField,
      required: true,
      options: {}
    },
    text: {
      label: messages.wiki.text,
      type: RichTextField,
      required: true
    },
    parent: {
      label: messages.wiki.node,
      required: true,
      type: TreeSelectField,
      options: {
        async values (scope: any) {
          let list = await store.dispatch('wiki/getNodesTree')
          return list;
        },
        treeProps: {
          label: 'title'
        },
        nodeKey: 'id'
      }
    }
  },
  steps: [
    {
      map: [
        ['title', 'text', 'parent']
      ]
    }
  ]
}

export default createForm